import initialState from './initialState';
import { reducer as loadAllExtensionReducer } from './loadAllExtension';
import { reducer as loadPluginFieldsReducer } from './loadPluginFields';
import { reducer as installPluginReducer } from './installPlugin';
import { reducer as loadAllInstalledPluginReducer } from './loadAllInstalledPlugin';
import { reducer as loadInstalledPluginDetailReducer } from './loadInstalledPluginDetail';
import { reducer as updateInstalledPluginReducer } from './updateInstalledPlugin';
import { reducer as deleteInstalledPluginReducer } from './deleteInstalledPlugin';
import { reducer as loadRolesReducer } from './loadRoles';
import { reducer as deletePermissionReducer } from './deletePermission';
import { reducer as loadEncryptInstalledPluginDetailReducer } from './loadEncryptInstalledPluginDetail';

const reducers = [
  loadAllExtensionReducer,
  loadPluginFieldsReducer,
  installPluginReducer,
  loadAllInstalledPluginReducer,
  loadInstalledPluginDetailReducer,
  updateInstalledPluginReducer,
  deleteInstalledPluginReducer,
  loadRolesReducer,
  deletePermissionReducer,
  loadEncryptInstalledPluginDetailReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
